import { useState } from 'react';
import ContractChartWidget from '../components/ContractChartWidget';
import RSIVWAPStudyTable from '../components/RSIVWAPStudyTable';

export default function BotTest() {
  const [selectedContract, setSelectedContract] = useState(null);

  return (
    <div>
      {/* RTH is forced because the signal's VWAP is computed on RTH-only bars
          (user spec: "For the Option charts we should only use RTH"). On the
          default GLOBAL session the chart's VWAP also accumulates overnight
          bars, which on an SPXW 0DTE that opened far higher sits ~$0.80
          above the RTH VWAP - enough to make a valid entry look invalid. */}
      {/* No rsiTriggerLevel: the trigger is now 20, which the RSI pane
          already draws as its green "Lower" band - a second line there would
          just overlap it. */}
      <ContractChartWidget
        contract={selectedContract}
        forceTf="5m"
        forceSession="regular"
      />
      <RSIVWAPStudyTable onSelect={setSelectedContract} />
    </div>
  );
}
